// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3k08B","summary":"CartItem_summary__ApAyb","price":"CartItem_price__2i17u","amount":"CartItem_amount__2qq81","actions":"CartItem_actions__iHRPB"};